import PageLayout from "@/Themes/Default/Layouts/PageLayout";
import {withAuthenticationRequired} from "@auth0/auth0-react";
import React from "react";
import styled from "styled-components";
import UploadUserGuideModal from "@/Components/Modals/UploadUserGuideModal";
import {Card} from "primereact/card";
import {Button} from "primereact/button";

const StyledWrap = styled.main`
    .content-container {
        margin-top: 2rem;
        padding: 0 1rem;
    }
`;

const SettingsPage: React.FC = () => {
    const [uploadModalVisible, setUploadModalVisible] = React.useState(false);

    return (
        <PageLayout>
            <StyledWrap>
                <div className="content-container">
                    <Card title={'User guide'}>
                        <div className={'flex gap-2'}>
                            <Button
                                label="Download"
                                className="p-button-outlined p-button-secondary"
                            />
                            <Button
                                label="Upload"
                                onClick={() => setUploadModalVisible(true)}
                            />
                        </div>
                    </Card>
                </div>
            </StyledWrap>

            <UploadUserGuideModal
                dialogProps={{
                    visible: uploadModalVisible,
                    onHide: () => setUploadModalVisible(false)
                }}
            />
        </PageLayout>
    );
};

export default withAuthenticationRequired(SettingsPage);
